 export const FormatDateEnum = {
    DateTime: 'DateTime',
    Date: 'Date',
    Time: 'Time'
}